/**
 * Contenu français pour la fonctionnalité `community` (forums, discussions, Hall
 * des Légendes). Les clés correspondent aux appels `t('community.*')` dans
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityFr = {
  // CommunityPage
  'community.page.seoTitle': 'Communauté',
  'community.page.seoDescription':
    'Rejoins la communauté Grymwyrd : forums, théories du lore, outils de MJ, créations maison et Hall des Légendes.',
  'community.page.eyebrow': 'Le Rassemblement des Ténèbres',
  'community.page.title': 'Communauté',
  'community.page.intro':
    'Échange tes tactiques, élabore des théories, partage tes créations maison et élève-toi vers le canon. Chaque message que tu postes te rapporte des pièces et de la réputation dans le crépuscule éternel.',
  'community.page.loading': 'Rassemblement des fidèles…',
  'community.page.forumCategories': 'Catégories du Forum',
  'community.page.categoryStats': '{threads} discussions · {posts} messages',
  'community.page.recentActivity': 'Activité Récente',
  'community.page.liveFeed': 'flux en direct',
  'community.page.recentEmpty':
    'Les forums sont silencieux ce soir. Lance une discussion pour réveiller les morts.',
  'community.page.hallOfLegends': 'Hall des Légendes',
  'community.page.hallBlurb': 'Les plus grands contributeurs et les personnages qu\'ils ont forgés dans le canon.',
  'community.page.enterTheHall': 'Entrer dans le Hall',
  'community.page.playerSpotlights': 'Mise en Lumière des Joueurs',
  'community.page.summoningLegends': 'Invocation des légendes…',
  'community.page.sampleNotice': 'Affichage du contenu communautaire exemple en attendant l\'ouverture des forums en direct.',

  // FlagButton
  'community.flag.errorQueued':
    'Nous n\'avons pas pu joindre les modérateurs pour l\'instant, mais ton signalement a été mis en file d\'attente.',
  'community.flag.ariaLabel': 'Signaler ce message aux modérateurs',
  'community.flag.label': 'Signaler',
  'community.flag.modalTitle': 'Rapport aux Gardiens',
  'community.flag.successDelivered':
    'Ton rapport a été remis aux modérateurs. Les Gardiens te remercient.',
  'community.flag.close': 'Fermer',
  'community.flag.signInNotice':
    'Tu peux toujours décrire le problème, mais tu dois être connecté pour que le signalement parvienne aux modérateurs.',
  'community.flag.whyFlagging': 'Pourquoi signales-tu ce message ?',
  'community.flag.reason.spamOrAdvertising': 'Spam ou publicité',
  'community.flag.reason.harassmentOrAbuse': 'Harcèlement ou abus',
  'community.flag.reason.spoilersWithoutWarning': 'Spoilers sans avertissement',
  'community.flag.reason.offTopic': 'Hors sujet',
  'community.flag.reason.otherDescribeBelow': 'Autre (décris ci-dessous)',
  'community.flag.describeIssue': 'Décris le problème',
  'community.flag.detailPlaceholder': 'Dis aux Gardiens ce qui ne va pas…',
  'community.flag.cancel': 'Annuler',
  'community.flag.reporting': 'Signalement en cours…',
  'community.flag.submitReport': 'Envoyer le rapport',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Forums',
  'community.category.seoDescription': 'Discussions du forum {name} sur Grymwyrd.',
  'community.category.breadcrumb': 'Communauté',
  'community.category.entityTiedPrefix': 'Forum lié à une entité · les discussions peuvent être liées à',
  'community.category.encyclopediaEntries': 'entrées de l\'encyclopédie',
  'community.category.sampleNotice': 'Affichage des discussions exemple en attendant l\'ouverture du forum en direct.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Hall des Légendes',
  'community.legends.seoDescription':
    'Les plus grands contributeurs à Grymwyrd et les personnages qu\'ils ont forgés dans le canon.',
  'community.legends.breadcrumb': 'Communauté',
  'community.legends.title': 'Hall des Légendes',
  'community.legends.intro':
    'Ici se tiennent les architectes du crépuscule éternel — les contributeurs dont les paroles sont devenues loi, et les personnages si bien-aimés qu\'ils ont été gravés dans le canon.',
  'community.legends.loading': 'Allumage des chandelles…',
  'community.legends.topContributors': 'Meilleurs Contributeurs',
  'community.legends.noContributors':
    'Aucune légende ne s\'est levée encore. Poste, élabore des théories et crée pour réclamer ta place.',
  'community.legends.canonizedCharacters': 'Personnages Canonisés',
  'community.legends.noCharacters':
    'Aucun personnage n\'a été canonisé encore. Le bestiaire attend son prochain cauchemar.',
  'community.legends.sampleNotice': 'Affichage des légendes exemple en attendant la consécration du hall en direct.',

  // NestedReplies
  'community.replies.replyBy': 'Réponse de {author}',
  'community.replies.reply': 'Répondre',
  'community.replies.replyToPlaceholder': 'Répondre à {author}…',
  'community.replies.unlike': 'Retirer ton j\'aime de ce message',
  'community.replies.like': 'Aimer ce message',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} réputation',
  'community.spotlight.viewInEncyclopedia': 'Voir {name} dans l\'encyclopédie',

  // PostComposer
  'community.composer.placeholder': 'Ajoute ta voix aux ténèbres…',
  'community.composer.signInPrompt': 'Connecte-toi pour rejoindre la discussion et gagne des pièces pour tes paroles.',
  'community.composer.signInToReply': 'Se connecter pour répondre',
  'community.composer.youFallback': 'Toi',
  'community.composer.saveError':
    'Ta réponse n\'a pas pu être sauvegardée sur le serveur pour l\'instant — elle est affichée localement uniquement.',
  'community.composer.writeReply': 'Rédige une réponse',
  'community.composer.writePost': 'Rédige un message',
  'community.composer.replyText': 'Texte de la réponse',
  'community.composer.postText': 'Texte du message',
  'community.composer.posting': 'Publication en cours…',
  'community.composer.postReply': 'Publier la réponse',
  'community.composer.post': 'Publier',
  'community.composer.cancel': 'Annuler',
  'community.composer.coinsPerPost': '+{count} pièces par message',
  'community.composer.coinsEarned': '+{count} pièces gagnées pour ton message !',

  // ThreadItem
  'community.thread.pinned': 'Discussion épinglée',
  'community.thread.byPrefix': 'par',
  'community.thread.repliesTitle': '{count} réponses',
  'community.thread.likesTitle': '{count} j\'aime',
  'community.thread.viewsTitle': '{count} vues',
  'community.thread.entityEntry': 'entrée {type}',

  // ThreadList
  'community.threadList.empty':
    'Aucune discussion n\'a encore émergé ici. Sois le premier à briser le silence.',

  // ThreadPage
  'community.threadPage.loading': 'Ouverture de la discussion…',
  'community.threadPage.seoDescription': 'Une discussion dans les forums communautaires de Grymwyrd.',
  'community.threadPage.replyCount': '{count} réponses',
  'community.threadPage.opened': 'ouvert il y a {time}',
  'community.threadPage.entityEntry': 'entrée {type}',
  'community.threadPage.sampleNotice': 'Affichage de la discussion exemple en attendant l\'ouverture du forum en direct.',
  'community.threadPage.openingPostBy': 'Message d\'ouverture de {author}',
  'community.threadPage.repliesHeading': 'Réponses',
  'community.threadPage.noReplies': 'Aucune réponse encore. Sois le premier à répondre à l\'appel.',
  'community.threadPage.addYourReply': 'Ajoute ta réponse',
} as const
